import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useFlowcodeCountQuery } from '@dtx-company/inter-app/src/redux/slices/flowcodeApiSlice/userQueries'

export const useGetCodesCount = (): { count: number; loading: boolean } => {
  const { jwt, isAuthenticated } = useAuthState()
  const { data, isLoading } = useFlowcodeCountQuery(
    {},
    {
      skip: !isAuthenticated || !jwt?.token,
      refetchOnMountOrArgChange: true
    }
  )

  return {
    count: data?.me?.flowcodeCount ?? 0,
    loading: isLoading
  }
}
